import { render, staticRenderFns } from "./TRT_Notifications.vue?vue&type=template&id=ae52bd14&scoped=true&"
import script from "./TRT_Notifications.vue?vue&type=script&lang=js&"
export * from "./TRT_Notifications.vue?vue&type=script&lang=js&"
import style0 from "./TRT_Notifications.vue?vue&type=style&index=0&id=ae52bd14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae52bd14",
  null
  
)

export default component.exports